import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";


function AMC_Report({ adminData, branchID }) {


  const [noteType, setNoteType] = useState(null);
  const [fetchData, setfetchData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [branchDetail, setBranchDetail] = useState([])
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };

  const reportOptions = [
    { value: 'machine_in_amc', label: 'Machine In AMC' },
    { value: 'expired_amc', label: 'Expired AMC' },
    { value: 'service_card', label: 'Service Card/Service Done' },

  ]



  const handleSearch = async (e) => {
    e.preventDefault();

    if (!fromDate || !toDate) {
      setToast('Please select both From Date and To Date', 'warning');
      return;
    }

    try {
      const params = {
        noteType: noteType?.value,
        from_date: fromDate,
        to_date: toDate,
      };

      const result = await axios.get('https://api.skyguard.group/api/get-amc-report', { params });
      const resultData = result?.data?.result || [];


      if (noteType?.value === 'service_card') {
        const fromDateObj = new Date(fromDate);
        const toDateObj = new Date(toDate);

        const filteredData = resultData
          .map((row) => {
            let visits = [];
            try {
              visits = Array.isArray(row.visits) ? row.visits : JSON.parse(row.visits || '[]');
            } catch {
              visits = [];
            }

            const filteredVisits = visits.filter((v) => {
              if (!v.visitDate) return false;
              const visitDateObj = new Date(v.visitDate);
              return !isNaN(visitDateObj) && visitDateObj >= fromDateObj && visitDateObj <= toDateObj;
            });

            return { ...row, visits: filteredVisits };
          })

          .filter((row) => row.visits.length > 0 || !row.visits);

        setfetchData(filteredData);
        console.log(filteredData)

        setToast(
          filteredData.length
            ? 'Service card report fetched successfully'
            : 'No service card data found in selected date range',
          filteredData.length ? 'success' : 'warning'
        );
        return;
      }

      if (noteType?.value === 'machine_in_amc' || noteType?.value === 'expired_amc') {
        setfetchData(resultData);

        setToast(
          resultData.length ? 'AMC report fetched successfully' : 'No AMC data found in selected date range',
          resultData.length ? 'success' : 'warning'
        );
        return;
      }

    } catch (error) {
      console.error('❌ Error fetching report:', error);
      setToast('Error fetching report. Please try again.', 'danger');
    }
  };


  const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };

  //  const handleExportExcel = () => {
  //       const table = document.getElementById("exportTable");

  //       if (!table) return;

  //       const worksheet = XLSX.utils.table_to_sheet(table);
  //       const workbook = XLSX.utils.book_new();

  //       XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");

  //       const excelBuffer = XLSX.write(workbook, {
  //         bookType: "xlsx",
  //         type: "array",
  //       });

  //       const data = new Blob([excelBuffer], {
  //         type:
  //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  //       });

  //       saveAs(data, "AMC_Report.xlsx");
  //     };

  const handlePrint = () => {
    const content = document.getElementById("exportTable");

    if (!content) return;

    const printWindow = window.open("", "", "width=900,height=700");

    // printWindow.document.write(`
    //   <html>
    //     <head>
    //       <title>AMC Report</title>
    //       <style>
    //         body {
    //           font-family: Arial, sans-serif;
    //           padding: 20px;
    //         }
    //         table {
    //           width: 100%;
    //           border-collapse: collapse;
    //         }
    //         table, th, td {
    //           border: 1px solid black;
    //         }
    //         th, td {
    //           padding: 8px;
    //           text-align: left;
    //         }
    //       </style>
    //     </head>
    //     <body>
    //       ${content.outerHTML}
    //     </body>
    //   </html>
    // `);


    printWindow.document.write(`
  <html>
    <head>
      <title>AMC Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 10px;
          margin: 0;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: auto;
          word-wrap: break-word;
        }

        th, td {
          border: 1px solid black;
          padding: 6px;
          font-size: 12px;
        }

        /* Prevent overflow */
        div {
          overflow: visible !important;
        }

        /* Fit content inside page */
        @page {
          size: A4 landscape;
          margin: 10mm;
        }
      </style>
    </head>
    <body>
      ${content.outerHTML}
    </body>
  </html>
`);
    printWindow.document.close();
    printWindow.focus();

    // Wait for content to load, then print
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };
  return (
    <>

      <div className='main-section'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <h3 className='my-3 fw-bold fs-5 golos'>AMC Report</h3>
          <div className="row g-3 align-items-end">
            <div className="col-md-4">
              <label className='fw-bold'>Select Report</label>
              <Select
                options={reportOptions}
                placeholder="Choose Type ..."
                id="source"
                value={noteType}

                onChange={(selected) => {
                  setNoteType(selected);
                  setfetchData([]);
                }}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>From Date</label>
              <input
                type="date"
                className="form-control"
                name="from_date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>To Date</label>
              <input
                type="date"
                className="form-control"
                name="to_date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>


            <div className="col-md-12 d-flex justify-content-end align-items-end">
              {/* <button className="btn btn-primary" onClick={handleSearch} >Search</button> */}
              <FaSearch size={26} className="ms-1 text-primary"
                style={{ cursor: "pointer" }}
                title="Search"
                onClick={handleSearch}
              />

              <MdLocalPrintshop
                size={26}
                className="ms-1 text-success"
                onClick={handlePrint}
                style={{ cursor: "pointer" }}
                title="Print "
              />
            </div>
          </div>


          
          <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <h4 className="text-center mb-3 fw-bold">
              {noteType?.label || "AMC Report"}
            </h4>

            {noteType?.value === 'machine_in_amc' ? (

              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Doc No</th>
                    <th>Party Name</th>
                    <th>Machine Name</th>
                    <th>Sr No</th>
                    <th>Installed In</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.flatMap((row, rowIdx) => {
                      let itemsArr = [];
                      try {
                        itemsArr = typeof row.items === 'string' ? JSON.parse(row.items) : row.items || [];
                      } catch {
                        itemsArr = [];
                      }

                      if (itemsArr.length === 0) {
                        return (
                          <tr key={`${rowIdx}-noitem`}>
                            <td>{`AMC/${row.id}/branch`}</td>
                            <td>{row.party_name}</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{formatDateTime(row.start_date)}</td>
                            <td>{formatDateTime(row.end_date)}</td>
                            <td>{row.grand_total}</td>
                          </tr>
                        );
                      }

                      return itemsArr.map((it, itIdx) => (
                        <tr key={`${rowIdx}-${itIdx}`}>
                          <td>{`AMC/${row.id}/branch`}</td>
                          <td>{row.party_name}</td>
                          <td>{it.name}</td>
                          <td>{Array.isArray(it.sr_no) ? it.sr_no.join(', ') : '-'}</td>
                          <td>{it.install || '-'}</td>
                          <td>{formatDateTime(row.start_date)}</td>
                          <td>{formatDateTime(row.end_date)}</td>
                          <td>{row.grand_total}</td>
                        </tr>
                      ));
                    })
                  ) : (
                    <tr>
                      <td colSpan="8">No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : noteType?.value === 'expired_amc' ? (

              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                    <th>Doc No</th>
                    <th>Party Name</th>
                    <th>Machine Name</th>
                    <th>Sr No</th>
                    <th>Installed In</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.flatMap((row, rowIdx) => {
                      let itemsArr = [];
                      try {
                        itemsArr = typeof row.items === 'string' ? JSON.parse(row.items) : row.items || [];
                      } catch {
                        itemsArr = [];
                      }

                      if (itemsArr.length === 0) {
                        return (
                          <tr key={`${rowIdx}-noitem`}>
                            <td>{`AMC/${row.id}/branch`}</td>
                            <td>{row.party_name}</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{formatDateTime(row.start_date)}</td>
                            <td>{formatDateTime(row.end_date)}</td>
                            <td>{row.grand_total}</td>
                          </tr>
                        );
                      }

                      return itemsArr.map((it, itIdx) => (
                        <tr key={`${rowIdx}-${itIdx}`}>
                          <td>{`AMC/${row.id}/branch`}</td>
                          <td>{row.party_name}</td>
                          <td>{it.name}</td>
                          <td>{Array.isArray(it.sr_no) ? it.sr_no.join(', ') : '-'}</td>
                          <td>{it.install || '-'}</td>
                          <td>{formatDateTime(row.start_date)}</td>
                          <td>{formatDateTime(row.end_date)}</td>
                          <td>{row.grand_total}</td>
                        </tr>
                      ));
                    })
                  ) : (
                    <tr>
                      <td colSpan="8">No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : noteType?.value === 'service_card' ? (

              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                    <th>Customer Name</th>
                    <th>Machine Name</th>
                    <th>Sr No.</th>
                    <th>Service Date</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.flatMap((row, rowIdx) => {
                      let itemsArr = [];
                      try {
                        itemsArr = typeof row.items === 'string' ? JSON.parse(row.items) : row.items || [];
                      } catch {
                        itemsArr = [];
                      }

                      const visitsArr = Array.isArray(row.visits) ? row.visits : [];

                      if (visitsArr.length === 0) {
                        return itemsArr.map((it, itIdx) => {
                          const srNo = Array.isArray(it.sr_no) ? it.sr_no.join(', ') : '-';
                          return (
                            <tr key={`${rowIdx}-${itIdx}-novisit`}>
                              <td>{row.party_name}</td>
                              <td>{it.name}</td>
                              <td>{srNo}</td>
                              <td>-</td>
                            </tr>
                          );
                        });
                      }

                      return itemsArr.flatMap((it, itIdx) => {
                        const srNo = Array.isArray(it.sr_no) ? it.sr_no.join(', ') : '-';
                        return visitsArr.map((v, vIdx) => {
                          const visitDate = v.visitDate ? new Date(v.visitDate).toLocaleString() : '-';
                          return (
                            <tr key={`${rowIdx}-${itIdx}-${vIdx}`}>
                              <td>{row.party_name}</td>
                              <td>{it.name}</td>
                              <td>{srNo}</td>
                              <td>{visitDate}</td>
                            </tr>
                          );
                        });
                      });
                    })
                  ) : (
                    <tr>
                      <td colSpan="4">No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : null}
          </div>


        </div>
      </div>
    </>
  )
}

export default AMC_Report